import { createColumnHelper } from "@tanstack/react-table";

import CrudActions from "components/crud/CrudActions";

const columnHelper =
    createColumnHelper();


export const organizationColumns = ({
    onEdit,
    onDelete,
    master,
}) => [

    // =========================================================
    // NAME
    // =========================================================

    columnHelper.accessor(
        "name",
        {
            id: "name",

            header:
                master === "business-regions"
                    ? "Region Name"
                    : "Name",

            cell: (info) => (
                <span
                    className="
                        font-semibold
                        text-gray-700
                    "
                >
                    {info.getValue() || "-"}
                </span>
            ),
        }
    ),


    // =========================================================
    // CODE
    // =========================================================

    columnHelper.accessor(
        "code",
        {
            id: "code",

            header:
                master === "business-regions"
                    ? "Region Code"
                    : "Code",

            cell: (info) => (
                <span
                    className="
                        font-medium
                        text-gray-600
                    "
                >
                    {info.getValue() || "-"}
                </span>
            ),
        }
    ),


    // =========================================================
    // STATUS
    // =========================================================

    columnHelper.accessor(
        "status",
        {
            id: "status",

            header: "Status",

            cell: (info) => {

                const status =
                    info.getValue();

                const isActive =
                    status === "active";

                return (
                    <span
                        className={`
                            inline-flex
                            rounded-full
                            border
                            px-3
                            py-1
                            text-xs
                            font-semibold
                            capitalize

                            ${
                                isActive
                                    ? `
                                        border-green-200
                                        bg-green-50
                                        text-green-700
                                      `
                                    : `
                                        border-red-200
                                        bg-red-50
                                        text-red-700
                                      `
                            }
                        `}
                    >
                        {status || "-"}
                    </span>
                );
            },
        }
    ),


    // =========================================================
    // ACTIONS
    // =========================================================

    columnHelper.display({

        id: "actions",

        header: "Actions",

        cell: ({ row }) => {

            const item =
                row.original;

            return (
                <CrudActions
                    showEdit={
                        typeof onEdit ===
                        "function"
                    }

                    onEdit={
                        onEdit
                            ? () =>
                                onEdit(item)
                            : undefined
                    }

                    editTitle={
                        master ===
                        "business-regions"
                            ? "Edit Business Region"
                            : "Edit Organization"
                    }


                    showDelete={
                        typeof onDelete ===
                        "function"
                    }

                    onDelete={
                        onDelete
                            ? () =>
                                onDelete(
                                    item.id
                                )
                            : undefined
                    }

                    deleteTitle={
                        master ===
                        "business-regions"
                            ? "Delete Business Region"
                            : "Deactivate Organization"
                    }
                />
            );
        },
    }),
];